module.exports = __webpack_public_path__ + "media/apps/gif-ios-56-firstframe-eb5e69b4.jpg";